import { WS_BASE_URL, WS_PATH } from "@lib/constants/AppConst";
import redux from "@lib/redux";
import { setConnectionStatus, setError } from "@lib/redux/slices/websocket";
import { NotifyMessagePayload } from "@lib/types/Notification";
import { io, Socket } from "socket.io-client";

class WebSocketClass {
  private socket: Socket | null = null;
  private static instance: WebSocketClass | null = null;
  private isInitialized: boolean = false;

  private constructor() {
    redux.subscribe(() => {
      const { accessToken } = redux.getState().auth?.user || {};
      if (accessToken && !this.isInitialized) {
        this.init();
      }
    });
  }

  public static getInstance(): WebSocketClass {
    if (!WebSocketClass.instance) {
      WebSocketClass.instance = new WebSocketClass();
    }
    return WebSocketClass.instance;
  }

  public init() {
    const { accessToken } = redux.getState().auth?.user || {};

    if (!accessToken) {
      console.log("Access token not available, waiting for authentication...");
      return;
    }

    if (this.socket) {
      console.log("Disconnecting existing socket connection");
      this.socket.disconnect();
    }

    try {
      console.log("Creating new socket connection to:", WS_BASE_URL);
      this.socket = io(WS_BASE_URL, {
        path: WS_PATH,
        transports: ["websocket", "polling"],
        auth: {
          token: accessToken,
        },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        timeout: 20000,
        autoConnect: true,
        forceNew: false,
        multiplex: true,
      });

      this.handleConnection();
      this.isInitialized = true;
    } catch (error) {
      console.error("Error creating socket connection:", error);
      redux.dispatch(setError("Failed to create socket connection"));
    }
  }

  public getSocket() {
    return this.socket;
  }

  private handleConnection() {
    if (!this.socket) {
      console.log("Socket is null, cannot handle connection");
      return;
    }

    this.socket.on("connect", () => {
      console.log("Socket Connected successfully");
      redux.dispatch(setConnectionStatus(true));
      redux.dispatch(setError(null));
    });

    this.socket.on("connect_error", (error) => {
      console.error("Socket Connection Error:", error);
      redux.dispatch(setError(`Connection Error: ${error.message}`));
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Socket Disconnected, reason:", reason);
      redux.dispatch(setConnectionStatus(false));
      redux.dispatch(setError(`Socket Disconnected: ${reason}`));
    });

    this.socket.on("error", (error) => {
      console.error("Socket Error:", error);
      redux.dispatch(setError(`Socket Error: ${error}`));
    });
  }

  public handleNotifyMessage(data: NotifyMessagePayload) {
    // console.log("🚀 ~ handleNotifyMessage ~ data:", data);
    navigator?.serviceWorker?.controller?.postMessage({
      type: "NOTIFY_MESSAGE",
      payload: { data },
    });
  }
}

const WebSocketService = WebSocketClass.getInstance();
export default WebSocketService;
